<template>
  <div class="c-services-summary">
    <div class="component" style="background-color: #ffad1f" v-if="true == false &&
      (lead.brand_val == 'BMW' ||
        lead.brand_val == 'MINI' ||
        lead.brand_val == 'BMW Motorrad')
    ">
      <h3 style="color: #1c69d4">Specjalna oferta na zimę!</h3>
      <p>
        Umów się online na dowolną wymianę układu hamulcowego i zyskaj 15% rabatu na
        części i usługę! *
      </p>
      <p>
        <small> *nie dotyczy modeli BMW M </small>
      </p>
    </div>
    <div class="component">
      <div class="c-services-summary__head">
        <img src="@/assets/service.jpg" alt="service" class="c-services-summary__icon" /> Wybrane usługi
      </div>
      <br />
      <p>{{ lead.services_name.join(', ') }}</p>
      <p>
        Łączny szacowany czas wykonania usług: <b>{{  getSummaryServicesTimeText  }}</b>
      </p>
    </div>
    <div class="component">
      <div class="c-services-summary__head">
        <img src="@/assets/car.jpg" alt="BMW" class="c-services-summary__icon" />Dane Twojego pojazdu<br />
      </div>
      <h3 class="text--light">{{ lead.registration_number }}</h3>
      <h3 class="text--light text--gray">{{ lead.vin }}</h3>
      <p>
        {{ getModels.filter((e) => e.id == lead.model_id).map((e) => "BMW " + e.name)[0] }}
      </p>
    </div>
    <div class="component">
      <div class="c-services-summary__head">
        <img src="@/assets/pin.jpg" alt="pin" class="c-services-summary__icon" /> Dane wizyty
      </div>
      <div class="mb--1" v-if="getSelectedDealer">
        <strong>{{ getSelectedDealer.name }}</strong>
        <br />
        {{ getSelectedDealer.address }}, {{ getSelectedDealer.postal_code }}
        {{ getSelectedDealer.city }}
      </div>
      <br />
      Data przyjęcia
      <br />
      <ul v-if="!lead.date">
        <li v-if="lead.date_from">
          od
          {{ getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(lead.date_from)]}}
          {{ lead.date_from }}
        </li>
        <li v-else>Możliwie najszybciej</li>
      </ul>
      <ul v-else>
        <li>
          {{ getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(lead.date)] }}
          {{ lead.date }}
        </li>
      </ul>
      <br />
      <template v-if="lead.visit_hour_val || lead.hour">
        Godzina przyjęcia
        <br />
        <ul>
          <li v-if="lead.hour">{{ lead.hour }}</li>
          <li v-else>
            {{ getTimeOfDay.find((e) => e.val == lead.visit_hour_val).name }}
          </li>
        </ul>
      </template>
      <template v-if="lead.additional_options_val.length > 0">
        <hr class="mt--1" />
        <span v-for="additionalOption in getAdditionalOptions.filter((e) => lead.additional_options_val.includes(e.val))">
          &check; {{ additionalOption.name }}<br />
        </span>
        <ul v-if="lead.replacement_car_id" class="mt--1">
          <li>
            {{
              getReplacementCars
                .filter((e) => (e.id == lead.replacement_car_id ? e.model : false))
                .map((e) => e.brand + " " + e.model)[0]
            }}
          </li>
        </ul>
      </template>

      <template v-if="lead.subAdditionalOptions.length > 0">
        <hr class="mt--1" />
        <span v-for="subAdditionalOption in lead.subAdditionalOptions">
          &check; {{ subAdditionalOption }}<br />
        </span>
      </template>

    </div>
    <div class="component">
      <div class="c-services-summary__head">
        <img src="@/assets/comment.jpg" alt="comment" class="c-services-summary__icon" /> Twój komentarz
      </div>
      <br />
      <template v-if="lead.comment_val">
        Komentarz
        <br />
        ( {{ lead.comment_val }} )
      </template>
      <template v-else> Brak komentarza </template>
    </div>
  </div>
</template>
<script>
import lead from "@/mixins/lead.js";
import { mapGetters } from "vuex";
export default {
  mixins: [lead],
  computed: {
    ...mapGetters({
      getModels: "definitions/getModels",
      getDealers: "definitions/getDealers",
      getTimeOfDay: "definitions/getTimeOfDay",
      getReplacementCars: "definitions/getReplacementCars",
      getDetepickerConfig: "definitions/getDetepickerConfig",
    }),
    getSelectedDealer() {
      return this.getDealers.find((e) => e.id == this.lead.dealer_id);
    },
  },
};
</script>
<style lang="scss">
.c-services-summary {
  @media (min-width: 1208px) {
    position: sticky;
    top: 1rem;
  }

  &__icon {
    width: 24px;
    // image-rendering: pixelated;
  }

  .component {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }

  &__head {
    display: flex;
    justify-content: flex-start;
    gap: .5rem;
    align-items: center;
    font-weight: bold;
    margin-bottom: 1rem;
  }
}
</style>
